import { useTranslation } from "react-i18next";
import { CalendarX } from "lucide-react";

// حالة الغياب: تجاوز مدة السماح أو انتهاء مهلة الانصراف يعني أن اليوم سُجّل غياباً — لا كاميرا ولا تسجيل.
export const AbsentNotice = ({ check, onClose }) => {
  const { t } = useTranslation();
  const closed = check.key === "checkout_window";
  const boxes = closed
    ? [["absent.deadline", check.deadline_local || "-"], ["absent.grace", `${check.grace_minutes || 0} ${t("app.minutes")}`]]
    : [
        ["absent.lateBy", `${check.late_minutes} ${t("app.minutes")}`],
        ["absent.allowed", `${check.allowed_minutes} ${t("app.minutes")}`],
      ];
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-4 py-6 text-center"
      data-testid="absent-notice">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-destructive/15 shadow-neu-in">
        <CalendarX className="h-9 w-9 text-destructive" />
      </span>
      <div>
        <p className="text-xl font-black text-destructive" data-testid="absent-notice-title">
          {t(closed ? "absent.closedTitle" : "absent.title")}
        </p>
        <p className="mx-auto mt-2 max-w-xs text-sm font-semibold text-muted-foreground">
          {closed
            ? t("absent.closedReason", { deadline: check.deadline_local || "-" })
            : t("absent.reason", { late: check.late_minutes, allowed: check.allowed_minutes })}
        </p>
      </div>
      <div className="grid w-full max-w-xs grid-cols-2 gap-2">
        {boxes.map(([label, value]) => (
          <div key={label} className="rounded-2xl bg-background p-3 shadow-neu-sm">
            <p className="text-[10px] font-bold text-muted-foreground">{t(label)}</p>
            <p className="mt-1 font-mono text-lg font-black" dir="ltr">{value}</p>
          </div>
        ))}
      </div>
      <p className="max-w-xs text-xs text-muted-foreground">{t("absent.hint")}</p>
      <button
        type="button"
        data-testid="absent-notice-close"
        onClick={onClose}
        className="rounded-2xl bg-primary px-6 py-3 text-sm font-bold text-primary-foreground"
      >
        {t("app.close")}
      </button>
    </div>
  );
};
